import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Mail, Sparkles, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let interval;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        if (data.payment_status === "paid") clearInterval(interval);
      } catch {}
      setAttempts((a) => a + 1);
    };
    poll();
    interval = setInterval(poll, 2500);
    return () => clearInterval(interval);
  }, [sessionId]);

  const paid = status?.payment_status === "paid";
  const failed = attempts > 20 && !paid;

  return (
    <div data-testid="payment-success" className="min-h-screen flex items-center justify-center rose-grain p-6">
      <div className="card-luxe p-10 max-w-lg w-full text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <Sparkles className="text-[var(--brand-primary)]" size={24}/>
          <span className="font-heading text-xl">Valeriia Nail Academy</span>
        </Link>
        {paid ? (
          <>
            <CheckCircle2 className="mx-auto text-[var(--brand-primary)] mb-4" size={64}/>
            <h1 className="font-heading text-4xl mb-3">¡Pago confirmado!</h1>
            <p className="text-[var(--text-muted)] mb-6">
              Tu compra de <strong>{status.tier_name}</strong> se ha completado. Hemos enviado tus credenciales de acceso a <strong>{status.email}</strong>.
            </p>
            <div className="bg-[var(--brand-primary-light)] p-4 rounded-lg mb-6 flex items-start gap-3 text-left">
              <Mail className="text-[var(--brand-primary)] mt-0.5" size={20}/>
              <p className="text-sm">Revisa tu bandeja de entrada (y spam). El email puede tardar hasta 2 minutos en llegar.</p>
            </div>
            <Link to="/login" data-testid="go-to-login" className="btn-brand w-full justify-center">Ir al acceso</Link>
          </>
        ) : failed ? (
          <>
            <h1 className="font-heading text-3xl mb-3">Estamos confirmando tu pago…</h1>
            <p className="text-[var(--text-muted)] mb-6">Recibirás un email en cuanto se procese. Si tarda demasiado escríbenos a valeriia@nailacademy.es</p>
            <Link to="/" className="btn-outline-brand">Volver al inicio</Link>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto animate-spin text-[var(--brand-primary)] mb-4" size={48}/>
            <h1 className="font-heading text-3xl mb-2">Procesando tu pago…</h1>
            <p className="text-[var(--text-muted)]">Un momento por favor.</p>
          </>
        )}
      </div>
    </div>
  );
}
